'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TargetLineContainer = undefined;

var _isNumber = require('d2-utilizr/lib/isNumber');

var _isNumber2 = _interopRequireDefault(_isNumber);

var _Style = require('./Style');

var _Style2 = _interopRequireDefault(_Style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TargetLineContainer = function TargetLineContainer(refs) {
    var i18n = refs.i18nManager.get();

    var container = Ext.create('Ext.container.Container', {
        layout: 'column',
        bodyStyle: 'border:0 none'
    });

    container.targetLineValueInput = Ext.create('Ext.form.field.Number', {
        width: _Style2.default.numberWidth,
        height: _Style2.default.numberHeight,
        listeners: {
            change: function change(nf) {
                container.targetLineTitleInput.xable();
            }
        }
    });

    container.targetLineTitleInput = Ext.create('Ext.form.field.Text', {
        style: 'margin-left:1px; margin-bottom:1px',
        fieldStyle: 'padding-left:3px',
        emptyText: i18n.target_line_title,
        width: _Style2.default.cmpWidth - _Style2.default.labelWidth - 5 - _Style2.default.numberWidth - 1,
        maxLength: 100,
        enforceMaxLength: true,
        disabled: true,
        xable: function xable() {
            this.setDisabled(!container.targetLineValueInput.getValue() && !(0, _isNumber2.default)(container.targetLineValueInput.getValue()));
        }
    });

    container.add([{
        layout: 'column',
        bodyStyle: 'border:0 none; padding-top:3px; margin-right:5px; color:#333',
        width: 130,
        html: i18n.target_line_value_title
    }, container.targetLineValueInput, container.targetLineTitleInput]);

    return container;
};

exports.TargetLineContainer = TargetLineContainer;
exports.default = TargetLineContainer;
//# sourceMappingURL=TargetLine.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/ui/options/TargetLine.js
 ** module id = 362
 ** module chunks = 0
 **/